


























import { mapMutations } from "vuex";
import Vue from "vue";

export default Vue.extend({
  name: "VInstrumentCard",
  props: {
    instrument: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations(["setCurrentInstrument"])
  },
  filters: {
    truncateHistory(history: string[]): string {
      if (history.length > 3) {
        return history.slice(0, 3).join(", ") + ", ...";
      }
      return history.join(", ");
    }
  }
});
